import { Box } from '@hivebrite/design-system/Box';
import { Loader } from '@hivebrite/design-system/Loader';

import NewsIndexClientStandalone from 'hb-react/frontoffice/apps/NewsIndex/startup/NewsIndexClientStandalone';
import GenericErrorBanner from 'hb-react/publicoffice/components/GenericErrorBanner';
import {
  ROUTE_TAG_APP_PAGES,
  ROUTE_TAG_CURRENT_NETWORK,
  ROUTE_TAG_FEATURES,
} from 'hb-react/publicoffice/constants/routeTags';
import useNetworkConfiguration from 'hb-react/publicoffice/utils/useNetworkConfiguration';

const NETWORK_ROUTE_TAGS = [
  {
    routeTag: ROUTE_TAG_FEATURES,
    // Brittle optimization:
    // Loading 'amplitude' to match the params from CookieBannerAppStandalone so both
    // queries will share the same queryKey
    params: { app_names: ['cookies', 'amplitude'] },
  },
  {
    routeTag: ROUTE_TAG_APP_PAGES,
    params: { app_name: 'news' },
  },
  {
    routeTag: ROUTE_TAG_CURRENT_NETWORK,
  },
];

const NewsAppClientStandalone = () => {
  const { networkConfiguration, isError } = useNetworkConfiguration({
    styleNeeded: false,
    networkRouteTags: NETWORK_ROUTE_TAGS,
  });

  if (isError) {
    return <GenericErrorBanner />;
  }

  if (!networkConfiguration) {
    return (
      <Box alignItems="center" height="100vh" justifyContent="center">
        <Loader size={50} />
      </Box>
    );
  }

  const { colors, appPagesData, theming, featuresData, currentNetwork } =
    networkConfiguration;

  const networkProps = {
    ...currentNetwork,
    ...featuresData,
    colors: colors?.colors,
    theming: theming?.theming,
  };
  const pageProps = appPagesData || {};

  return <NewsIndexClientStandalone network={networkProps} page={pageProps} />;
};

export default NewsAppClientStandalone;
